import SimpleDataWithVariation from '@/language/pt/components/cards/models/SimpleDataWithVariation';
import CardWithTitle from '@/language/pt/components/cards/models/CardWithTitle';
import PieChart from '@/language/pt/components/cards/models/PieChart';
import TogglePieChart from '@/language/pt/components/cards/models/TogglePieChart';

export default {
  SimpleDataWithVariation,
  CardWithTitle,
  PieChart,
  TogglePieChart,
};
